import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../modal/Modal';
import { Button } from '../../shared/ui';
import styles from './PhotoSourcePopup.module.css';

export default function PhotoSourcePopup({ open, onClose, onLibrary }) {
  const { t } = useTranslation();

  return (
    <Modal modalOpen={open} setModalOpen={onClose}>
      {open ? (
        <div className={styles.sheet} role="dialog" aria-labelledby="photo-source-title">
          <p id="photo-source-title" className={styles.title}>
            {t('photoSource.title')}
          </p>
          <Button variant="outline" className={styles.option} onClick={onLibrary}>
            <span className={styles.optionLabel}>{t('photoSource.library')}</span>
          </Button>
          <Button variant="outline-alt" className={styles.option} onClick={() => onClose(false)}>
            <span className={styles.optionLabel}>{t('photoSource.cancel')}</span>
          </Button>
        </div>
      ) : null}
    </Modal>
  );
}
